import React from 'react'
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar'
import WorkIcon from '@mui/icons-material/Work'
import LocationOnIcon from '@mui/icons-material/LocationOn'
import PeopleIcon from '@mui/icons-material/People'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'
import locale from 'utils/locale'
import { getItem } from 'utils/localstorage'
import { pathOr } from 'ramda'

export const userData = getItem('userData')
export const roleId = pathOr('', ['vendor', 'role_id'], userData)

export const appNavigatorItems = {
  navigatorWidth: 265,
  navigatorItems: [
    {
      id: 0,
      text: locale('Lots'),
      key: 'lotsView',
      icon: <DirectionsCarIcon />,
      options: [
        {
          id: 0,
          text: locale('Distributed'),
          key: 'distributed',
          parentKey: 'lotsView',
        },
        {
          id: 1,
          text: locale('Completed'),
          key: 'completed',
          parentKey: 'lotsView',
        },
        {
          id: 2,
          text: locale('Issues Reported By Me'),
          key: 'reportedIssues',
          parentKey: 'lotsView',
        },
        {
          id: 3,
          text: locale('Issues Assigned To Me'),
          key: 'assignedIssues',
          parentKey: 'lotsView',
        },
      ],
    },
    {
      id: 1,
      text: locale('Trips'),
      key: 'tripsView',
      icon: <LocationOnIcon />,
      options: [
        {
          id: 0,
          text: locale('Assigned'),
          key: 'assigned',
          parentKey: 'tripsView',
        },
        {
          id: 1,
          text: locale('Acknowledged'),
          key: 'acknowledged',
          parentKey: 'tripsView',
        },
        {
          id: 2,
          text: locale('Declined Trips Reported By Me'),
          key: 'reportedDeclinedTrips',
          parentKey: 'tripsView',
        },
        {
          id: 3,
          text: locale('Declined Trips Assigned To Me'),
          key: 'reportedAssignedTrips',
          parentKey: 'tripsView',
        },
      ],
    },
    {
      id: 2,
      text: locale('Drivers'),
      key: 'driversView',
      icon: <PeopleIcon />,
    },
    {
      id: 3,
      text: locale('Work Requests'),
      key: 'workRequestsView',
      icon: <WorkIcon />,
    },
    ...(roleId === 1
      ? [
          {
            id: 4,
            text: locale('Daily Capacities'),
            key: 'dailyCapacitiesView',
            icon: <CalendarMonthIcon />,
          },
        ]
      : []),
  ],
}

export const appNavigatorItemsConst = {
  LOTS: 'lotsView',
  TRIPS: 'tripsView',
  DRIVERS: 'driversView',
  WORK_REQUESTS: 'workRequestsView',
  CAPACITIES: 'dailyCapacitiesView',
}

export const appNavigatorDisplayNames = {
  [appNavigatorItemsConst.LOTS]: locale('Lots'),
  [appNavigatorItemsConst.TRIPS]: locale('Trips'),
  [appNavigatorItemsConst.DRIVERS]: locale('Drivers'),
  [appNavigatorItemsConst.WORK_REQUESTS]: locale('Work Requests'),
  [appNavigatorItemsConst.CAT_TOW_PROVIDERS]: locale('Cat Tow Providers'),
  [appNavigatorItemsConst.CAPACITIES]: locale('Daily Capacities'),
}

export const placeholdersMapping = {
  lotsView: 'Search with Lot Number/VRN',
  tripsView: 'Search with Trip ID',
  driversView: 'Search with Driver Name',
}

export const viewSearchColumns = {
  lotsView: 'lot_number',
  tripsView: 'trip_id',
}
